import React from 'react';
import { Box } from '@mui/material';
import VideoPlayerSection from './VideoPlayerSection';
import TranscriptSection from '../Video/TranscriptSection';
import SummarySection from '../Summary/SummarySection';
import QASection from '../QA/QASection';

const MobileColumnLayout = ({
  activeColumn,
  swipeHandlers,
  // 비디오 관련
  isStreaming,
  analyzedVideoId,
  analyzedTitle,
  analyzedUrl,
  selectedHistory,
  onPlayerStateChange,
  playerRef,
  // 자막 관련
  scriptArr,
  activeIdx,
  autoScroll,
  setAutoScroll,
  scriptRefs,
  transcriptLoading,
  showTranslated,
  handleToggleTranslation,
  currentTranscript,
  // 요약 관련
  loading,
  streamingSummary,
  streamingChapters,
  activeTab,
  setActiveTab,
  streamingChunkSummaries,
  setActiveColumn,
  // QA 관련
  qaInput,
  setQaInput,
  qaLoading,
  handleQaSend,
  qaHistory,
  recommendedQuestions,
  handleRecommendedQuestionClick,
  qaScrollRef
}) => {
  return (
    <Box 
      {...swipeHandlers}
      className="swipe-container"
      onTouchStart={(e) => {
        // iOS Safari 조건부 바운스 방지를 위한 제어
        // 멀티터치만 방지, 단일 터치는 허용
        if (e.touches.length > 1) {
          e.preventDefault();
        }
      }}
      onTouchMove={(e) => {
        // 조건부 페이지 스크롤 방지
        // 스크롤 가능한 영역 확인
        const target = e.target;
        const scrollableParent = target.closest('.scrollable-content');
        
        if (!scrollableParent) {
          // 스크롤 가능한 영역이 아닌 경우에만 조건부 차단
          const touch = e.touches[0];
          const isHeaderArea = touch.clientY < 100;
          
          // 헤더 영역이 아닌 곳에서의 터치는 차단
          if (!isHeaderArea) {
            e.preventDefault();
          }
        }
        // 스크롤 가능한 영역에서는 모든 터치 이벤트 허용 (자연스러운 바운스 포함)
      }}
      sx={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        transition: 'transform 0.3s ease-out',
        overflow: 'hidden',
        touchAction: 'pan-y',
        WebkitTouchCallout: 'none',
        WebkitUserSelect: 'none',
        userSelect: 'none'
      }}
    >
      {/* 컬럼 0: 비디오 + 자막 */}
      <Box sx={{ 
        height: '100%',
        display: activeColumn === 0 ? 'flex' : 'none',
        flexDirection: 'column',
        position: 'relative',
        animation: activeColumn === 0 ? 'fadeIn 0.3s ease-in' : 'none'
      }}>
        <Box sx={{
          position: 'relative',
          top: 0,
          zIndex: 1,
          backgroundColor: '#fff',
          flexShrink: 0
        }}>
          <VideoPlayerSection
            videoId={isStreaming ? analyzedVideoId : selectedHistory?.videoId}
            title={isStreaming ? analyzedTitle : selectedHistory?.title}
            onPlayerStateChange={onPlayerStateChange}
            playerRef={playerRef}
            isMobile={true}
          />
        </Box>
        
        <Box sx={{ 
          flex: 1,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          display: 'flex', 
          flexDirection: 'column',
          pb: 2
        }}>
          <TranscriptSection
            scriptArr={scriptArr}
            activeIdx={activeIdx}
            autoScroll={autoScroll}
            setAutoScroll={setAutoScroll}
            scriptRefs={scriptRefs}
            playerRef={playerRef}
            loading={transcriptLoading}
            transcript={selectedHistory?.transcript}
            translatedTranscript={selectedHistory?.translatedTranscript}
            showTranslated={showTranslated}
            onToggleTranslation={handleToggleTranslation}
            key={selectedHistory?.id}
          />
        </Box>
      </Box>

      {/* 컬럼 1: 요약 */}
      <Box sx={{ 
        height: '100%',
        display: activeColumn === 1 ? 'block' : 'none',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        animation: activeColumn === 1 ? 'fadeIn 0.3s ease-in' : 'none',
        pb: 2
      }}>
        <SummarySection
          summaryLoading={loading}
          summary={streamingSummary || selectedHistory?.summary || ''}
          detailContent={
            streamingChapters.length > 0
              ? streamingChapters
              : (Array.isArray(selectedHistory?.chapters)
                  ? selectedHistory.chapters
                  : selectedHistory?.chapters?.chapters || [])
          }
          isStreaming={isStreaming}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          playerRef={playerRef}
          streamingChunkSummaries={
            streamingChunkSummaries.length > 0
              ? streamingChunkSummaries
              : selectedHistory?.chunk_summaries || []
          }
          transcript={currentTranscript}
          setActiveMainTab={setActiveColumn}
          videoUrl={isStreaming ? analyzedUrl : selectedHistory?.url}
          videoTitle={isStreaming ? analyzedTitle : selectedHistory?.title}
          key={selectedHistory?.id}
        />
      </Box>

      {/* 컬럼 2: QA */}
      <Box sx={{ 
        height: '100%',
        display: activeColumn === 2 ? 'block' : 'none',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        animation: activeColumn === 2 ? 'fadeIn 0.3s ease-in' : 'none',
        pb: 2
      }}>
        <QASection
          qaInput={qaInput}
          setQaInput={setQaInput}
          qaLoading={qaLoading}
          handleQaSend={handleQaSend}
          qaHistory={qaHistory}
          recommendedQuestions={recommendedQuestions}
          handleRecommendedQuestionClick={handleRecommendedQuestionClick}
          qaScrollRef={qaScrollRef}
          summary={selectedHistory?.summary}
          chapters={
            Array.isArray(selectedHistory?.chapters)
              ? selectedHistory.chapters
              : selectedHistory?.chapters?.chapters || []
          }
          key={selectedHistory?.id}
        />
      </Box>
    </Box>
  );
};

export default MobileColumnLayout; 